import React, { FC, useState } from "react";
import { Button, Col, Row, Tag, Typography } from "antd";
import moment from "moment";
import { FileTextOutlined, MessageOutlined } from "@ant-design/icons";
import { CommentCardElement } from "./CommentCardElement";
import { CommentCardHeader, Wrapper } from "./styled";
import { ConditionalTooltipText } from "../ConditionalTooltipText";
import { DocumentsModal } from "../DocumentsModal";
import { ResponsibleEngineerItem } from "./ResponsibleEngineerItem";
import { TitleRow } from "../../components/WDCard/styled";
import { commentsTabs } from "../../constants";
import { TCommentShortData, TCommentsTab } from "../../types";
// import { observer } from "mobx-react-lite";
// import { userRolesStore } from "stores";

interface ICommentCardProps {
  comment: TCommentShortData;
  isHighlighted?: boolean;
  messagesCount?: { partnersChat: number; internalChat?: number };
  onClick: () => void;
  status: TCommentsTab;
}

const pickTitleByCommentStatus = {
  [commentsTabs[0]]: "Создано",
  [commentsTabs[1]]: "Принято в работу",
  [commentsTabs[2]]: "Отклонено",
  [commentsTabs[3]]: "Отработано",
};

export const CommentCard: FC<ICommentCardProps> = ({
  comment,
  isHighlighted = false,
  messagesCount = { partnersChat: 0, internalChat: 0 },
  onClick,
  status,
}) => {
  const [isOpenDocumentsModal, setOpenDocumentsModal] = useState(false);

  const handleClickVersion = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setOpenDocumentsModal(true);
  };

  return (
    <Wrapper
      $isHighlighted={isHighlighted}
      onClick={() => (isOpenDocumentsModal ? undefined : onClick())}
    >
      {isOpenDocumentsModal && !!comment.versionList?.length && (
        <DocumentsModal
          onCancel={() => setOpenDocumentsModal(false)}
          onChoosePdf={() => {}}
          selectedDocument={{
            title: (
              <TitleRow align="middle">
                <Typography.Title level={5}>Актуальная РД</Typography.Title>
                <Typography.Title
                  level={5}
                >{`— версия ${comment.version}`}</Typography.Title>
              </TitleRow>
            ),
            documents: comment.versionList,
          }}
        />
      )}

      <CommentCardHeader align="middle" justify="space-between">
        <Row align="middle" gutter={16}>
          <Col>
            <Tag className="comment-card-tag" color={"#e6f4ff"}>
              <Typography.Text color={"#1677ff"}>
                {comment.number}
              </Typography.Text>
            </Tag>
          </Col>

          <Col>
            <Typography.Text
              className="comment-card-project-name"
              color={"#595959"}
              strong
            >
              {comment.project.name}
            </Typography.Text>
          </Col>

          {/* {userRolesStore.isNotJustCustomer() &&
            !!comment.responsibleEngineers?.length && ( */}
              <Col className="comment-card-responsible-engineers-column">
                <Row gutter={8}>
                  {comment.responsibleEngineers!.map((el) => (
                    <ResponsibleEngineerItem
                      fullName={el.fullName}
                      role={el.position}
                      key={el.id}
                    />
                  ))}
                </Row>
              </Col>
            {/* )} */}
        </Row>

        <Row align="middle" className="comment-card-notifications" wrap={false}>
          {!!messagesCount.partnersChat && (
            <>
              <MessageOutlined />

              <Typography.Text color={"#595959"} strong>
                {messagesCount.partnersChat}
              </Typography.Text>
            </>
          )}

          {!!messagesCount.internalChat && (
            <>
              <FileTextOutlined  className="internal-chat-icon" />

              <Typography.Text color={"#595959"} strong>
                {messagesCount.internalChat}
              </Typography.Text>
            </>
          )}
        </Row>
      </CommentCardHeader>

      <ConditionalTooltipText rows={2} text={comment.title} />

      <CommentCardElement description={comment.kitName} title="Комплект" />
      <CommentCardElement
        description={comment.documentation.name}
        title="Том"
      />
      <CommentCardElement
        extraContent={
          status === commentsTabs[3] ? (
            <Button
              className="version-button"
              onClick={handleClickVersion}
              type="link"
            >
              Версия {comment.version}
            </Button>
          ) : null
        }
        description={moment(comment.updateTime ?? comment.createdAt).format()}
        title={pickTitleByCommentStatus[status]}
      />
    </Wrapper>
  );
};
